(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-deadline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jl-deadline')) {
    customElements.define('jl-deadline', class extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.deadline).getTime();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const left = this.end - Date.now();
        if (!(left > 0)) {
          this.querySelectorAll('[data-before]').forEach((e) => (e.hidden = true));
          this.querySelectorAll('[data-after]').forEach((e) => (e.hidden = false));
          clearInterval(this.timer);
          return;
        }
        const s = Math.floor(left / 1000);
        const parts = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
        for (const [k, v] of Object.entries(parts)) this.querySelector(`[data-u="${k}"]`).textContent = String(v).padStart(2, '0');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
